module.exports = __webpack_public_path__ + "static/media/file-type-pdf.443a61c5.png";